import React,{useState} from 'react';
import './styles/App.css';
import M_Footer from './M_Footer';
import DriveInfo from './DriveInfo';
import TopTitle from './TopTitle';
import {Link} from 'react-router-dom';
import axios from 'axios';
import queryString from 'query-string';
import { instance } from './common';


function DriverInform({ history, location, match }) {

  const borderNone = {border: '0'}

    const mgstyle = {
        marginTop:"50px",
        marginBottom:"100px"
    }
    const bradius = {
        borderRadius:"7px"
    }

    const query = queryString.parse(location.search);
    let cate = query.cate;
    console.log('cate ???? ', cate);

    const onClick = () => {
        history.push('/carmaster?cate='+cate);
        
    }


    const goBack = () => {
        history.goBack();
    }

    const myinfo = JSON.parse(window.sessionStorage.result);
    console.log('myinfo  : ', myinfo);
    const {u_car_name,u_car_number,u_car_date,} = myinfo;
    const obj= myinfo;
    loadCar(obj);
    console.log('obj: ', obj)
    const mySize = {
        marginTop:"30px",
        marginBottom:"80px"
    }
    
  return (
      <>
        <TopTitle title="Driver 정보관리"/>
         <DriveInfo />
         <div className="container" style={mgstyle}>
            <div className="row">
                <div className="id mb-4">
                        <div className="input text-left font-weight-bold">이름</div>
                        <div>
                            <input name="u_car_name" className="userId" type="text" id="nameInput" readOnly/>
                        </div>
                    </div>
                    <div className="id mb-4">
                        <div className="input text-left font-weight-bold">연락처</div>
                        <div>
                            <input name="u_user_number" className="userId" type="text" id="telInput" readOnly/>
                        </div>
                    </div>
                    <div className="id mb-4" style={borderNone}>
                        <div className="col-6 pl-0 d-inline-block">
                            <div className="input text-left font-weight-bold">거주지역</div>
                                <input name="u_user_number" className="detail_address form-control" type="text" id="addr1" readOnly/>
                            
                        </div>
                        <div className="col-6 d-inline-block pr-0">
                            <div className="input text-left font-weight-bold">상세주소</div>
                                <input name="u_user_number" className="detail_address form-control" type="text" id="addr2" readOnly/>
                        </div>     
                    </div>
                    <div className="loginbtn w-100">
                         <button type="button" className="btn btn-primary w-100 pt-3 pb-3 mb-3" style={bradius} onClick={onClick}>다음</button>
                         <button type="button" className="btn btn-primary w-100 pt-3 pb-3" style={bradius} onClick={goBack}>이전</button>
                    </div>
            </div>    
         </div>
      
      
      
         <M_Footer />
      </>


  );
}

function loadCar(obj){
    // console.log('obj : ', obj);
    const {u_car_number} = obj;
    // console.log('u_car_number  : ', u_car_number)
    instance.post('/users/same-number',{
        u_car_number:u_car_number
    })
    .then(function (response) {
        // handle success
        const data = response.data;;
        const driver = data.filter((v) => {
            return v.u_type === '일반고객';
        });

        
        // console.log("driver: ", driver)
        if(driver.length !==0){
            document.getElementById('nameInput').value = driver[0].u_nick;
            document.getElementById('telInput').value = driver[0].u_phone;
            document.getElementById('addr1').value = driver[0].u_address1;
            document.getElementById('addr2').value = driver[0].u_address2;
        }

        const driver2 = data.filter((v) => {
            return v.u_type === '카마스터';
        });
        // if(driver2.length !==0){
        //     document.getElementById('nameInput').value = driver2[0].u_nick;
        //     document.getElementById('telInput').value = driver2[0].u_phone;
        // }
        
        
    })
    .catch(function (error) {
        // handle error
        console.log(error);
    })
}

export default DriverInform;